import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import previewPdf from '../views/PreviewPDF.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
   {
    path: '/previewPdf',
    name: 'previewPdf',
    component: previewPdf
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  mode:'hash',
  routes
})

export default router
